import React from 'react';
import { motion } from 'framer-motion';
import { FiCpu, FiZap, FiTarget } from 'react-icons/fi';
import Hero from '../../components/sections/Hero';
import AuditForm from '../../components/sections/AuditForm';
import SEO from '../../components/common/SEO';
import SafeIcon from '../../components/common/SafeIcon';
import { servicesData } from '../../data/services';

const AEOPage = () => {
  const data = servicesData['aeo'];
  
  return (
    <>
      <SEO title={`${data.title} | Alberta SEO Pro`} description={data.description} />
      <Hero title={data.title} subtitle={data.longDesc} />
      <section className="py-20 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold mb-4">Be the Answer AI Gives</h2>
            <p className="text-slate-400 max-w-2xl mx-auto">Traditional search is evolving. We make sure Large Language Models (LLMs) trust your data.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {data.features.slice(0, 3).map((feature, i) => (
              <div key={i} className="bg-slate-800 p-8 rounded-2xl border border-slate-700 hover:border-orange-500 transition-colors">
                <div className="w-12 h-12 bg-orange-600/20 rounded-lg flex items-center justify-center text-orange-500 mb-6">
                  <SafeIcon icon={i === 0 ? FiCpu : i === 1 ? FiZap : FiTarget} className="text-2xl" />
                </div>
                <h3 className="text-xl font-bold mb-3">{feature}</h3>
                <p className="text-slate-400 text-sm">Strategic implementation to ensure AI models prioritize your business over competitors.</p>
              </div>
            ))}
          </div>
          <div className="mt-16 bg-white text-slate-900 p-10 rounded-3xl">
             <div className="grid lg:grid-cols-2 gap-12 items-center">
                <div>
                  <h3 className="text-2xl font-bold mb-4">Are you ready for AI Search?</h3>
                  <p className="text-slate-600 mb-6">Most websites are invisible to AI crawlers. We fix the technical gap that stops ChatGPT and Gemini from recommending your services.</p>
                  <AuditForm />
                </div>
                <div className="hidden lg:block bg-slate-100 rounded-2xl p-6">
                  <div className="space-y-4">
                    <div className="p-4 bg-white rounded-lg shadow-sm border border-slate-200">
                      <p className="text-xs text-orange-600 font-bold mb-1 uppercase">AI Query</p>
                      <p className="font-medium italic">"Who is the most reliable HVAC contractor in Edmonton?"</p>
                    </div>
                    <div className="p-4 bg-orange-600 text-white rounded-lg shadow-md">
                       <p className="text-xs font-bold mb-1 uppercase opacity-80">AI Source Recommendation</p>
                       <p className="font-medium">"According to multiple local verified sources, [Your Company] is the top-rated specialist..."</p>
                    </div>
                  </div>
                </div>
             </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AEOPage;